import Home from '../views/Home.vue'
import Users from '../views/users/UsersParent.vue'
import TimeTrackings from '../views/time-trackings/TimeTrackings.vue'
import Municipalities from '../views/municipality/MunicipalityParent.vue'
import MunicipalityMap from '../views/municipality-map/MunicipalityMapParent.vue'
import Clients from '../views/client/ClientParent.vue'
import ClientContacts from '../views/client-contact/ClientContactParent.vue'
import ClientMap from '../views/client-map/ClientMapParent.vue'
import Contacts from '../views/contact/ContactParent.vue'
import Business from '../views/business/BusinessParent.vue'
import BusinessContacts from '../views/business-contact/BusinessContactParent.vue'
import County from '../views/county/CountyParent'
import CountyContacts from '../views/county-contact/CountyContactParent.vue'
import Campaigns from '../views/campaign/CampaignParent.vue'
import AutoCampaigns from '../views/auto-campaign/AutoCampaignParent.vue'
import Deliveries from '../views/delivery/DeliveryParent.vue'
import LOBCosts from '../views/lob-costs/LOBCostsParent.vue'
import Carnivore from '@/views/carnivore/CarnivoreParent'
import ArCollections from '@/views/ar-collections/ArCollectionsParent.vue'
import Department from '@/views/department/DepartmentParent'
import Login from '../views/auth/Login.vue'
import Register from '../views/auth/Register.vue'
import Account from '../views/account/Account.vue'
import ForgotPassword from '../views/auth/ForgotPassword.vue'
import ResetPassword from '../views/auth/ResetPassword.vue'
import SetPassword from '../views/auth/SetPassword.vue'
import SettingsParent from '../views/settings/SettingsParent.vue'
import Dashboard from '../views/Dashboard.vue'
import Activities from '../views/activity/Activities'
import ActivitiesNew from '../views/activity/ActivitiesNew'
import middleware from './middleware'
import DataTable from '@/views/data/DataTable'
import JuniperDashboard from '@/views/juniper/Dashboard'
import JuniperHome from '@/views/juniper/Home'
import OnboardingDashboard from '@/views/onboarding/Dashboard'
import OnboardingHome from '@/views/onboarding/Home'
import KpiDashboard from '@/views/kpi/Dashboard'
import KpiHome from '@/views/kpi/Home'
import CwpeParent from '@/views/cwpe/CwpeParent.vue'
import Page404 from '@/views/Page404'
import Page403 from '@/views/Page403'

export default [
	{
		path: '/login',
		name: 'login',
		component: Login,
		beforeEnter: middleware.guest,
	},
	{
		path: '/register',
		name: 'register',
		component: Register,
		beforeEnter: middleware.guest,
	},
	{
		path: '/forgot-password',
		name: 'forgotPassword',
		component: ForgotPassword,
		beforeEnter: middleware.guest,
	},
	{
		path: '/reset-password',
		name: 'resetPassword',
		component: ResetPassword,
		beforeEnter: middleware.guest,
	},
	{
		path: '/set-password',
		name: 'setPassword',
		component: SetPassword,
		beforeEnter: middleware.guest,
	},

	{
		path: '/',
		component: Dashboard,
		props: { permission: '' },
		beforeEnter: middleware.user,
		children: [
			{
				path: '',
				component: Home,
				name: 'home',
			},
			// Municipalities
			{
				path: '/municipalities',
				component: Municipalities,
				props: { permission: 'MUNICIPALITY_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'municipality',
						component: () => import(/* webpackChunkName: "municipality" */ '../views/municipality/Municipalities.vue'),
					},
					{
						path: 'edit/:id',
						name: 'municipalityEdit',
						component: () => import(/* webpackChunkName: "municipality" */ '../views/municipality/MunicipalityEdit.vue'),
					},
					{
						path: 'import',
						name: 'importMunicipalities',
						component: () => import(/* webpackChunkName: "municipality" */ '../views/municipality/MunicipalitiesImport.vue'),
					},
				],
			},
			// Municipality Map
			{
				path: '/municipality-map',
				component: MunicipalityMap,
				props: { permission: 'MUNICIPALITY_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'municipalityMap',
						component: () => import(/* webpackChunkName: "clientContacts" */ '../views/municipality-map/MunicipalityMap.vue'),
					},
					{
						path: 'polygons',
						name: 'municipalityMapPolygons',
						component: () => import(/* webpackChunkName: "clientContacts" */ '../views/municipality-map/MunicipalityMapPolygons.vue'),
					},
				],
			},
			// Municipality Missing
			{
				path: '/municipalities-missing',
				component: MunicipalityMap,
				props: { permission: 'MUNICIPALITY_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'municipalityMissing',
						component: () => import(/* webpackChunkName: "clientContacts" */ '../views/municipality-missing/MunicipalityMissing.vue'),
					},
				],
			},
			// Clients
			{
				path: '/clients',
				component: Clients,
				props: { permission: 'CLIENT_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'client',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/Clients.vue'),
					},
					{
						path: 'notifications',
						name: 'slientsNotifications',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientsNotifications.vue'),
					},
					{
						path: 'statistics',
						name: 'clientsStatistics',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientStatistics.vue'),
					},
					{
						path: 'cancellations',
						name: 'cancellationWorklist',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/CancellationWorklist.vue'),
					},
				{
					path: 'recurrence',
					name: 'clientsRecurrence',
					component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientRecurrence.vue'),
				},
					{
						path: 'edit/:id',
						name: 'clientsEdit',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientEdit.vue'),
					},
					{
						path: 'edit/:id/billing',
						name: 'clientBilling',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientBilling.vue'),
					},
					{
						path: 'edit/:id/billing/invoices',
						name: 'clientInvoices',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientInvoices.vue'),
					},
					{
						path: 'edit/:id/billing/email-notifications',
						name: 'clientBillingEmailNotifications',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientBillingEmailNotifications.vue'),
					},
					{
						path: 'edit/:id/billing/letter-notifications',
						name: 'clientBillingLetterNotifications',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientBillingLetterNotifications.vue'),
					},
					{
						path: 'edit/:id/subscribers',
						name: 'clientsSubscribers',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientsSubscribers.vue'),
					},
					{
						path: 'import',
						name: 'importClients',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientsImport.vue'),
					},
					{
						path: 'dns',
						name: 'clientsDns',
						component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientsDns.vue'),
					},
				],
			},
			// AR Collections
			{
				path: '/ar-collections',
				component: ArCollections,
				props: { permission: '' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'arCollections',
						component: () => import(/* webpackChunkName: "ar-collections" */ '../views/ar-collections/ArCollections.vue'),
					},
				],
			},
			// Client contacts
			{
				path: '/client-contacts',
				component: ClientContacts,
				props: { permission: 'CLIENT_CONTACT_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'clientContacts',
						component: () => import(/* webpackChunkName: "clientContacts" */ '../views/client-contact/ClientContacts.vue'),
					},
					{
						path: 'edit/:id',
						name: 'clientContactsEdit',
						component: () => import(/* webpackChunkName: "clientContacts" */ '../views/client-contact/ClientContactEdit.vue'),
					},
					{
						path: 'import',
						name: 'importClientContacts',
						component: () => import(/* webpackChunkName: "clientContacts" */ '../views/client-contact/ClientContactsImport.vue'),
					},
				],
			},
			// Client Map
			{
				path: '/client-map',
				component: ClientMap,
				props: { permission: 'CLIENT_CONTACT_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'clientMap',
						component: () => import(/* webpackChunkName: "clientContacts" */ '../views/client-map/ClientMap.vue'),
					},
				],
			},
			// Contacts
			{
				path: '/contacts',
				component: Contacts,
				props: { permission: 'CONTACT_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'contact',
						component: () => import(/* webpackChunkName: "contacts" */ '../views/contact/Contacts.vue'),
					},
					{
						path: 'edit/:id',
						name: 'contactsEdit',
						component: () => import(/* webpackChunkName: "contacts" */ '../views/contact/ContactEdit.vue'),
					},
					{
						path: 'import',
						name: 'importContacts',
						component: () => import(/* webpackChunkName: "contacts" */ '../views/contact/ContactsImport.vue'),
					},
				],
			},
			// Counties
			{
				path: '/counties',
				component: County,
				props: { permission: 'CONTACT_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'county',
						component: () => import(/* webpackChunkName: "counties" */ '../views/county/Counties.vue'),
					},
					{
						path: 'edit/:id',
						name: 'countyEdit',
						component: () => import(/* webpackChunkName: "counties" */ '../views/county/CountyEdit.vue'),
					},
				],
			},
			// County Contacts
			{
				path: '/county-contacts',
				component: CountyContacts,
				props: { permission: 'CONTACT_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'countyContact',
						component: () => import(/* webpackChunkName: "countyContacts" */ '../views/county-contact/CountyContacts.vue'),
					},
					{
						path: 'edit/:id',
						name: 'countyContactsEdit',
						component: () => import(/* webpackChunkName: "countyContacts" */ '../views/county-contact/CountyContactEdit.vue'),
					},
				],
			},
			// Businesses
			{
				path: '/businesses',
				component: Business,
				props: { permission: 'CONTACT_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'business',
						component: () => import(/* webpackChunkName: "businesses" */ '../views/business/Businesses.vue'),
					},
					{
						path: 'edit/:id',
						name: 'businessEdit',
						component: () => import(/* webpackChunkName: "businesses" */ '../views/business/BusinessEdit.vue'),
					},
				],
			},
			// Business Contacts
			{
				path: '/business-contacts',
				component: BusinessContacts,
				props: { permission: 'CONTACT_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'businessContact',
						component: () => import(/* webpackChunkName: "businessContacts" */ '../views/business-contact/BusinessContacts.vue'),
					},
					{
						path: 'edit/:id',
						name: 'businessContactsEdit',
						component: () => import(/* webpackChunkName: "businessContacts" */ '../views/business-contact/BusinessContactEdit.vue'),
					},
				],
			},
			// Departments
			{
				path: '/departments',
				component: Department,
				props: { permission: 'CONTACT_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'department',
						component: () => import(/* webpackChunkName: "departments" */ '../views/department/Departments.vue'),
					},
					{
						path: 'edit/:id',
						name: 'departmentEdit',
						component: () => import(/* webpackChunkName: "departments" */ '../views/department/DepartmentEdit.vue'),
					},
				],
			},
			// Campaigns
			{
				path: '/campaigns',
				component: Campaigns,
				props: { permission: 'CAMPAIGN_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'campaigns',
						component: () => import(/* webpackChunkName: "campaign" */ '../views/campaign/Campaigns.vue'),
					},
					{
						path: 'edit/:id',
						name: 'campaignsEdit',
						component: () => import(/* webpackChunkName: "campaign" */ '../views/campaign/CampaignsEdit.vue'),
					},
					{
						path: 'scheduled/:id',
						name: 'campaignScheduled',
						component: () => import(/* webpackChunkName: "campaign" */ '../views/campaign/CampaignScheduled.vue'),
					},
					{
						path: 'response-report/:campaignId',
						name: 'campaignResponseReport',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignResponseReport.vue'),
					},
					{
						path: 'sending/:id',
						name: 'campaignSending',
						component: () => import(/* webpackChunkName: "campaign" */ '../views/campaign/CampaignSending.vue'),
					},
					/* {
						path: 'import',
						name: 'importCampaigns',
						component: () =>
							import(/* webpackChunkName: "delivery"  '../views/delivery/DeliveriesImport.vue'),
					}, */
				],
			},
			// Auto Campaigns
			{
				path: '/auto-campaigns',
				component: AutoCampaigns,
				props: { permission: 'CAMPAIGN_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'autoCampaignHome',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignHome.vue'),
					},
					{
						path: 'list',
						name: 'autoCampaigns',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaigns.vue'),
					},
					{
						path: 'data-lists',
						name: 'autoCampaignsDataLists',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignsDataLists.vue'),
					},
					{
						path: 'data-lists/:id/items',
						name: 'DataListItems',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/DataListItems.vue'),
					},
					{
						path: 'create',
						name: 'createAutoCampaign',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/CreateAutoCampaign.vue'),
					},
					{
						path: 'create/triggers',
						name: 'createAutoCampaignWithTriggers',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignWithTriggersCreate.vue'),
					},
					{
						path: 'create/sequences',
						name: 'createAutoCampaignWithSequences',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignWithSequencesCreate.vue'),
					},
					{
						path: 'edit/:id',
						name: 'editAutoCampaign',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/EditAutoCampaignRouter.vue'),
					},
					{
						path: 'edit/:id/triggers',
						name: 'editAutoCampaignWithTriggers',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignWithTriggersEdit.vue'),
					},
					{
						path: 'edit/:id/sequences',
						name: 'editAutoCampaignWithSequences',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignWithSequencesEdit.vue'),
					},
					{
						path: 'runs/:id',
						name: 'autoCampaignRuns',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignRuns.vue'),
					},
					{
						path: 'email-report/:campaignType/:campaignId',
						name: 'campaignEmailReport',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/CampaignEmailReport.vue'),
					},
					{
						path: 'response-report/:campaignId',
						name: 'autoCampaignResponseReport',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignResponseReport.vue'),
					},
					{
						path: 'report/:runId',
						name: 'autoCampaignRunReport',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignRunReport.vue'),
					},
					{
						path: 'municipality-report/:campaignId/:runId/:municipalityId',
						name: 'autoCampaignMunicipalityReport',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/MunicipalityReport.vue'),
					},
					{
						path: 'settings',
						name: 'autoCampaignSettings',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignSettings.vue'),
					},
					{
						path: 'run/start/:runId',
						name: 'autoCampaignRunStart',
						component: () => import(/* webpackChunkName: "auto-campaign" */ '../views/auto-campaign/AutoCampaignRunStart.vue'),
					},
				],
			},
			// Deliveries
			{
				path: '/deliveries',
				component: Deliveries,
				props: { permission: 'DELIVERY_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'deliveries',
						component: () => import(/* webpackChunkName: "delivery" */ '../views/delivery/Deliveries.vue'),
					},
					{
						path: 'import',
						name: 'importCampaigns',
						component: () => import(/* webpackChunkName: "delivery" */ '../views/delivery/DeliveriesImport.vue'),
					},
				],
			},
			// LOB Costs
			{
				path: '/lob-costs',
				component: LOBCosts,
				props: { permission: 'CAMPAIGN_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'lobCosts',
						component: () => import(/* webpackChunkName: "lob-costs" */ '../views/lob-costs/LOBCosts.vue'),
					},
				],
			},
			// Users
			{
				path: '/users',
				component: Users,
				props: { permission: 'USER_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'users',
						component: () => import(/* webpackChunkName: "user" */ '../views/users/Users.vue'),
					},
					{
						path: ':id',
						component: () => import(/* webpackChunkName: "user" */ '../views/users/edit/EditParent.vue'),
						children: [
							{
								path: '',
								component: () => import(/* webpackChunkName: "user" */ '../views/users/edit/Overview.vue'),
								name: 'userOverview',
							},
							{
								path: 'information',
								component: () => import(/* webpackChunkName: "user" */ '../views/users/edit/Information.vue'),
								name: 'userInformation',
							},
							{
								path: 'timeline',
								component: () => import(/* webpackChunkName: "user" */ '../views/users/edit/Timeline.vue'),
								name: 'userTimeline',
							},
							{
								path: 'permissions',
								component: () => import(/* webpackChunkName: "user" */ '../views/users/edit/Permissions.vue'),
								name: 'userPermissions',
							},
						],
					},
				],
			},
			// TimeTrackings
			{
				path: '/time-trackings',
				component: TimeTrackings,
				props: { permission: 'USER_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'timeTrackings',
						component: () => import(/* webpackChunkName: "time-trackings" */ '../views/time-trackings/TimeTrackings.vue'),
					},
					/* {
						path: ':id',
						component: () => import('../views/users/edit/EditParent.vue'),
						children: [
							{
								path: '',
								component: () => import('../views/users/edit/Overview.vue'),
								name: 'userOverview',
							},
						],
					}, */
				],
			},

			//Carnivores
			{
				path: '/carnivores',
				component: Carnivore,
				props: { permission: 'CARNIVORE_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'carnivore',
						component: () => import(/* webpackChunkName: "delivery" */ '../views/carnivore/Carnivores.vue'),
					},
					{
						path: 'edit/:id',
						name: 'carnivoreEdit',
						component: () => import(/* webpackChunkName: "campaign" */ '../views/carnivore/CarnivoreEdit.vue'),
					},
					{
						path: 'work/:id/entry',
						name: 'carnivoreWork',
						component: () => import(/* webpackChunkName: "campaign" */ '../views/carnivore/CarnivoreWork.vue'),
					},
				],
			},
			// Account
			{
				path: '/account',
				component: Account,
				props: { permission: '' },
				meta: {
					title: 'Your account',
					backTo: '/',
				},
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						name: 'account',
						component: () => import(/* webpackChunkName: "user" */ '../views/account/General.vue'),
					},
					{
						path: 'password',
						component: () => import(/* webpackChunkName: "user" */ '../views/account/ChangePassword.vue'),
						name: 'accountPassword',
					},
					{
						path: 'information',
						component: () => import(/* webpackChunkName: "user" */ '../views/account/Information.vue'),
						name: 'accountInformation',
					},
					{
						path: 'social',
						component: () => import(/* webpackChunkName: "user" */ '../views/account/Social.vue'),
						name: 'accountSocial',
					},
					{
						path: 'notifications',
						component: () => import(/* webpackChunkName: "user" */ '../views/account/Notifications.vue'),
						name: 'accountNotifications',
					},
					{
						path: 'filters',
						component: () => import(/* webpackChunkName: "user" */ '../views/account/Filters.vue'),
						name: 'accountFilters',
					},
				],
			},
			// Settings
			{
				path: '/settings',
				component: SettingsParent,
				props: { permission: 'SETTINGS_GENERAL_ACCESS' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						component: () => import(/* webpackChunkName: "settings" */ '../views/settings/General.vue'),
						name: 'settingsGeneral',
					},
					{
						path: 'roles',
						component: () => import(/* webpackChunkName: "settings" */ '../views/settings/RolesPermissionsSettings.vue'),
						name: 'settingsRoles',
					},
					{
						path: 'integrations',
						component: () => import(/* webpackChunkName: "settings" */ '../views/settings/IntegrationsSettings.vue'),
						name: 'settingsIntegrations',
					},
					{
						path: 'hooks',
						component: () => import(/* webpackChunkName: "settings" */ '../views/settings/HooksSettings.vue'),
						name: 'settingsHooks',
					},
					{
						path: 'short-links',
						component: () => import(/* webpackChunkName: "settings" */ '../views/settings/ShortlinkSettings.vue'),
						name: 'settingsShortlinks',
					},
					{
						path: 'pricing-engine',
						component: () => import(/* webpackChunkName: "settings" */ '../views/settings/PricingSettings.vue'),
						name: 'settingsPricingEngine',
					},
					{
						path: 'template-fonts',
						component: () => import(/* webpackChunkName: "settings" */ '../views/settings/TemplateFontsSettings.vue'),
						name: 'settingsTemplateFonts',
					},
					// Legacy per-integration URLs → merged Integrations tab
					{ path: 'lob', redirect: '/settings/integrations' },
					{ path: 'freshbooks', redirect: '/settings/integrations' },
					{ path: 'salesforce', redirect: '/settings/integrations' },
					// Import/Export merged into the Municipalities tab
					{ path: 'import-export', redirect: '/settings/municipalities' },
					{
						path: 'modules',
						component: () => import(/* webpackChunkName: "settings" */ '../views/settings/ModulesSettings.vue'),
						name: 'settingsModules',
					},
					{
						path: 'audits',
						component: () => import(/* webpackChunkName: "settings" */ '../views/settings/AuditsSettings.vue'),
						name: 'settingsAudits',
					},
					// Legacy per-module URLs → merged Modules tab
					{ path: 'clients', redirect: '/settings/modules' },
					{ path: 'municipalities', redirect: '/settings/modules' },
				],
			},
			// HeyGov + ClerkMinutes sync
			{
				path: '/heygov-sync',
				component: () => import(/* webpackChunkName: "settings" */ '../views/settings/HeyGovSync.vue'),
				props: { permission: 'MUNICIPALITY_UPDATE' },
				beforeEnter: middleware.user,
				name: 'heygovSync',
			},
			{
				path: '/accounts',
				component: () => import(/* webpackChunkName: "clients" */ '../views/client/ClientSegments.vue'),
				props: { permission: 'CLIENT_ACCESS' },
				beforeEnter: middleware.user,
				name: 'clientSegments',
			},
			{
				path: '/accounts2',
				component: () => import(/* webpackChunkName: "clients" */ '../views/client/Accounts2.vue'),
				props: { permission: 'CLIENT_ACCESS' },
				beforeEnter: middleware.user,
				name: 'clientSegments2',
			},
			// Activities
			{
				path: '/activities',
				component: Activities,
				name: 'activities',
				props: { permission: 'USER_CREATE' },
				beforeEnter: middleware.user,
			},
			// Activities New
			{
				path: '/activities-new',
				component: ActivitiesNew,
				name: 'activitiesNew',
				props: { permission: 'USER_CREATE' },
				beforeEnter: middleware.user,
			},
			// Marketing Tools
			{
				path: '/marketing/utm',
				component: () => import(/* webpackChunkName: "marketing" */ '../views/marketing/UtmTracking.vue'),
				name: 'marketingUtm',
				props: { permission: 'MUNICIPALITY_ACCESS' },
				beforeEnter: middleware.user,
			},
			{
				path: '/marketing/chris-willow',
				component: () => import(/* webpackChunkName: "marketing" */ '../views/marketing/ChrisWillow.vue'),
				name: 'marketingChrisWillow',
				props: { permission: 'MUNICIPALITY_ACCESS' },
				beforeEnter: middleware.user,
			},
			{
				path: '/marketing/brands',
				component: () => import(/* webpackChunkName: "marketing" */ '../views/marketing/Brands.vue'),
				name: 'marketingBrands',
				props: { permission: 'MUNICIPALITY_ACCESS' },
				beforeEnter: middleware.user,
			},

			// Competitors
			{
				path: '/competitors',
				component: () => import(/* webpackChunkName: "competitors" */ '../views/competitor/Competitors.vue'),
				name: 'competitors',
				props: { permission: 'MUNICIPALITY_ACCESS' },
				beforeEnter: middleware.user,
			},
			{
				path: '/competitors/:id',
				component: () => import(/* webpackChunkName: "competitor" */ '../views/competitor/Competitor.vue'),
				name: 'competitor',
				props: { permission: 'MUNICIPALITY_ACCESS' },
				beforeEnter: middleware.user,
			},
			// Test New
			{
				path: '/data/:model',
				component: DataTable,
				name: 'dataTable',
				props: { permission: 'USER_CREATE' },
				beforeEnter: middleware.user,
			},
			// Server Monitoring
			{
				path: '/monitoring',
				name: 'monitoring',
				component: () => import(/* webpackChunkName: "monitoring" */ '../views/monitoring/ServerMonitoring.vue'),
				props: { permission: 'USER_ACCESS' },
			},
			// Pricing Engine v2 (pricing-discovery/PE-v2-build-plan.md). Sales screens for every user, admin screens role-gated.
			{
				path: '/pricing',
				component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/PricingParent.vue'),
				props: { permission: '' },
				beforeEnter: middleware.user,
				children: [
					{ path: '', name: 'pricingWho', component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/Who.vue') },
					{ path: 'quotes/:id/build', name: 'pricingBuild', component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/Build.vue') },
					{ path: 'quotes/:id/send', name: 'pricingSend', component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/Send.vue') },
					{ path: 'mine', name: 'pricingMine', component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/MyQuotes.vue') },
					{
						path: 'admin',
						name: 'pricingFinance',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/FinanceHome.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
					{
						path: 'admin/floors',
						name: 'pricingFloors',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/Floors.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
					{
						path: 'admin/bundles',
						name: 'pricingBundleValues',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/BundleValues.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
					{
						path: 'admin/people',
						name: 'pricingPeople',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/People.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
					{
						path: 'admin/competitors',
						name: 'pricingCompetitors',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/Competitors.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
					{
						path: 'admin/reports',
						name: 'pricingReports',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/Reports.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
					{
						path: 'admin/quotes',
						name: 'pricingQuotesAdmin',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/QuotesAdmin.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
					{
						path: 'admin/quotes/:id',
						name: 'pricingLineEditor',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/LineEditor.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
					{
						path: 'admin/catalog',
						name: 'pricingCatalog',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/Catalog.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
					{
						path: 'admin/rules',
						name: 'pricingRules',
						component: () => import(/* webpackChunkName: "pricing" */ '../views/pricing/admin/Rules.vue'),
						beforeEnter: middleware.pricingAdmin,
					},
				],
			},
			// CWPE — Clerkware Pricing Engine
			{
				path: '/cwpe',
				component: CwpeParent,
				props: { permission: '' },
				beforeEnter: middleware.user,
				children: [
					{
						path: '',
						redirect: 'lookup',
					},
					{
						path: 'lookup',
						name: 'cwpeLookup',
						component: () => import(/* webpackChunkName: "cwpe" */ '../views/cwpe/CwpeLookup.vue'),
					},
					{
						path: 'pricing',
						name: 'cwpePricing',
						component: () => import(/* webpackChunkName: "cwpe" */ '../views/cwpe/CwpePricing.vue'),
					},
					{
						path: 'quotes',
						name: 'cwpeQuotes',
						component: () => import(/* webpackChunkName: "cwpe" */ '../views/cwpe/CwpeQuotes.vue'),
					},
					{
						path: 'quotes/:id',
						name: 'cwpeQuoteDetail',
						component: () => import(/* webpackChunkName: "cwpe" */ '../views/cwpe/CwpeQuoteDetail.vue'),
					},
					{
						path: 'proposals',
						name: 'cwpeProposals',
						component: () => import(/* webpackChunkName: "cwpe" */ '../views/cwpe/CwpeProposals.vue'),
					},
					{
						path: 'proposals/:id',
						name: 'cwpeProposalDetail',
						component: () => import(/* webpackChunkName: "cwpe" */ '../views/cwpe/CwpeProposalDetail.vue'),
					},
					{
						path: 'settings',
						name: 'cwpeSettings',
						component: () => import(/* webpackChunkName: "cwpe" */ '../views/cwpe/CwpeSettings.vue'),
					},
				],
			},
		],
	},
	// Juniper CMS
	{
		path: '/juniper',
		component: JuniperDashboard,
		props: { permission: 'MUNICIPALITY_ACCESS' },
		beforeEnter: middleware.user,
		children: [
			{
				path: '',
				name: 'juniper',
				component: JuniperHome,
			},
			{
				path: 'clients',
				name: 'juniperClients',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/Clients.vue'),
			},
			{
				path: 'pdf-auditor',
				name: 'juniperPdfAuditor',
				meta: { permissionsOne: ['ada_auditor', 'view_clients'] },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/PdfAuditor.vue'),
			},
			{
				path: 'themes',
				name: 'themes',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/Themes.vue'),
			},
			{
				path: 'statistics',
				name: 'juniperStatistics',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/statistics/Statistics.vue'),
			},
			{
				path: 'accessibility-stats',
				name: 'juniperAccessibilityStats',
				meta: { permissionsAll: ['develop'] },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/AccessibilityStats.vue'),
			},
			{
				// before :clientId so "engine" isn't read as a client id
				path: 'accessibility-stats/engine',
				name: 'juniperAccessibilityEngineStats',
				meta: { permissionsAll: ['develop'] },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/AccessibilityEngineStats.vue'),
			},
			{
				path: 'accessibility-stats/:clientId',
				name: 'juniperAccessibilityClientStats',
				meta: { permissionsAll: ['develop'] },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/AccessibilityClientStats.vue'),
			},
			{
				// All clients' activity logs — same view as a client's Activities, without :id
				path: 'logs',
				name: 'juniperLogs',
				meta: { permissionsAll: ['develop'] },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientActivities.vue'),
			},
			{
				path: 'debugging',
				name: 'juniperDebugging',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/Debugging.vue'),
			},
			{
				path: 'clients/new',
				name: 'juniperClientNew',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientNew.vue'),
			},
			{
				path: 'clients/edit/:id',
				name: 'juniperClientEdit',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientEdit.vue'),
			},
			{
				path: 'clients/edit/:id/analytics',
				name: 'juniperClientAnalytics',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientAnalytics.vue'),
			},
			{
				path: 'clients/edit/:id/activities',
				name: 'juniperClientActivities',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientActivities.vue'),
			},
			{
				path: 'clients/edit/:id/static',
				name: 'juniperClientStatic',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientStatic.vue'),
			},
			{
				path: 'clients/edit/:id/deploy',
				name: 'juniperClientDeploy',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientDeploy.vue'),
			},
			{
				path: 'clients/edit/:id/users',
				name: 'juniperClientUsers',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientUsers.vue'),
			},
			{
				path: 'clients/edit/:id/settings',
				name: 'juniperClientSettings',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientSettings.vue'),
			},
			{
				path: 'clients/edit/:id/customizer',
				name: 'juniperClientCustomizer',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientCustomizer.vue'),
			},
			{
				path: 'clients/edit/:id/customizer2',
				name: 'juniperClientCustomizer2',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientCustomizer2.vue'),
			},
			{
				path: 'clients/edit/:id/menus',
				name: 'juniperClientMenus',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientMenus.vue'),
			},
			{
				path: 'clients/edit/:id/landing-pages',
				name: 'juniperClientLandingPages',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientLandingPages.vue'),
			},
			{
				path: 'clients/edit/:id/landing-pages/:lpId',
				name: 'juniperClientLandingPageCustomizer',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientLandingPageCustomizer.vue'),
			},
			{
				path: 'clients/edit/:id/widgets',
				name: 'juniperClientWidgets',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientWidgets.vue'),
			},
			{
				path: 'clients/edit/:id/departments',
				name: 'juniperClientDepartments',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientDepartments.vue'),
			},
			{
				path: 'clients/edit/:id/ada-auditor',
				name: 'juniperClientAdaAuditor',
				meta: { permissionsOne: ['ada_auditor', 'view_clients'] },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientAdaAuditor.vue'),
			},
			{
				path: 'clients/edit/:id/accessibility',
				name: 'juniperClientAccessibility',
				// No permission meta on purpose — same access as Settings, where this panel used to live.
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientAccessibility.vue'),
			},
			{
				path: 'clients/:id/upgrade-launch',
				name: 'juniperClientUpgradeLaunch',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientUpgradeLaunch.vue'),
			},
			{
				path: 'user-management',
				name: 'juniperUserManagement',
				meta: { permissionsOne: ['view_users', 'view_roles', 'view_permissions'] },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/users/Users.vue'),
				children: [
					{
						path: 'users',
						name: 'juniperUsers',
						meta: { permissionsAll: ['view_users'] },
						components: {
							b: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/users/UsersList.vue'),
						},
					},
					{
						path: 'user-roles',
						name: 'juniperUserRoles',
						meta: { permissionsAll: ['view_roles'] },
						components: {
							b: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/users/UserRoles.vue'),
						},
					},
					{
						path: 'user-permissions',
						name: 'juniperUserPermissions',
						meta: { permissionsAll: ['view_permissions'] },
						components: {
							b: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/users/UserPermissions.vue'),
						},
					},
				],
			},
			{
				path: 'clients/edit/:id/seo',
				name: 'juniperClientSeo',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/seo/Seo.vue'),
			},
			{
				path: 'clients/edit/:id/pages',
				name: 'juniperClientPages',
				meta: { contentType: 'pages' },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientContentList.vue'),
			},
			{
				path: 'clients/edit/:id/news-notices',
				name: 'juniperClientNewsNotices',
				meta: { contentType: 'news' },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientContentList.vue'),
			},
			{
				path: 'clients/edit/:id/redirections',
				name: 'juniperClientRedirections',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientRedirections.vue'),
			},
			{
				path: 'clients/edit/:id/search-replace',
				name: 'juniperClientSearchReplace',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientSearchReplace.vue'),
			},
			{
				path: 'clients/edit/:id/wp-import',
				name: 'wpImport',
				meta: { permissionsAll: ['wp_import'] },
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientWpImport.vue'),
			},
			{
				path: 'clients/edit/:id/ai-search',
				name: 'juniperClientAISearch',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientAISearch.vue'),
			},
			{
				path: 'clients/edit/:id/business',
				name: 'juniperClientEditBusiness',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/clients/ClientEditBusiness.vue'),
			},
			{
				path: 'settings',
				name: 'juniperSettings',
				component: () => import(/* webpackChunkName: "juniper" */ '../views/juniper/JuniperSettings.vue'),
			},
		],
	},
	// Onboarding
	{
		path: '/onboarding',
		component: OnboardingDashboard,
		props: { permission: 'MUNICIPALITY_ACCESS' },
		beforeEnter: middleware.user,
		children: [
			{
				path: '',
				name: 'onboarding',
				component: OnboardingHome,
			},
			{
				path: '/onboarding/list',
				name: 'onboardingList',
				component: () => import(/* webpackChunkName: "onboarding" */ '../views/onboarding/Onboardings.vue'),
			},
			{
				path: '/onboarding/progress/:id',
				name: 'onboardingProgress',
				component: () => import(/* webpackChunkName: "onboarding" */ '../views/onboarding/OnboardingProgress.vue'),
			},
			{
				path: '/onboarding/options',
				name: 'onboardingOptions',
				component: () => import(/* webpackChunkName: "onboarding" */ '../views/onboarding/OnboardingOptions.vue'),
			},
			{
				path: '/onboarding/edit/:id',
				name: 'onboardingEdit',
				component: () => import(/* webpackChunkName: "onboarding" */ '../views/onboarding/OnboardingEdit.vue'),
			},
		],
	},
	// KPI-s
	{
		path: '/kpi',
		component: KpiDashboard,
		props: { permission: 'MUNICIPALITY_ACCESS' },
		beforeEnter: middleware.user,
		children: [
			{
				path: '',
				name: 'kpi',
				component: KpiHome,
			},
			{
				path: '/kpi/payments',
				component: () => import(/* webpackChunkName: "kpi" */ '../views/kpi/KpiPayments.vue'),
			},
			{
				path: '/kpi/support',
				component: () => import(/* webpackChunkName: "kpi" */ '../views/kpi/KpiSupport.vue'),
			},
			{
				path: '/kpi/projects',
				component: () => import(/* webpackChunkName: "kpi" */ '../views/kpi/KpiProjects.vue'),
			},
			{
				path: '/kpi/development',
				component: () => import(/* webpackChunkName: "kpi" */ '../views/kpi/KpiDevelopment.vue'),
			},
		],
	},
	{
		path: '/403',
		name: 'Page403',
		component: Page403,
	},
	// and finally the default route, when none of the above matches:
	{
		path: '/:pathMatch(.*)*',
		name: 'Page404',
		component: Page404,
	},
]
